export default __webpack_public_path__ + "static/media/logoHD.09b251c1.png";